import { OccConfig } from '@spartacus/core';
import { ViewConfig } from '@spartacus/storefront';

export const knBrProductEndpointsConfig: OccConfig = {
  backend: {
    occ: {
      endpoints: {
        // tslint:disable:max-line-length
        product: {
          default:
            'knbr/customers/${customerId}/products/${productCode}?fields=DEFAULT,averageRating,images(FULL),classifications,manufacturer,numberOfReviews,categories(FULL),baseOptions,baseProduct,variantOptions,variantType',
          list: 'knbr/customers/${customerId}/products/${productCode}?fields=code,name,summary,price(formattedValue),images(DEFAULT,galleryIndex)',
          details:
            'knbr/customers/${customerId}/products/${productCode}?fields=code,name,summary,images(galleryIndex,FULL),stock(DEFAULT),description,url,manufacturer,categories(FULL),priceRange,multidimensional,configuratorType,tags,knbrPrice,minOrderQuantity,uom',
          attributes: 'knbr/customers/${customerId}/products/${productCode}?fields=classifications',
          variants:
            'knbr/customers/${customerId}/products/${productCode}?fields=name,purchasable,baseOptions(DEFAULT),baseProduct,variantOptions(DEFAULT),variantType',
        },
        productReviews: 'knbr/customers/${customerId}/products/${productCode}/reviews',
        productReferences:
          'knbr/customers/${customerId}/products/${productCode}/references?fields=DEFAULT,references(target(images(FULL)))',
        productSearch:
          'knbr/customers/${customerId}/products/search?fields=products(code,name,summary,price(FULL),images(DEFAULT),stock(FULL),averageRating,variantOptions,uom,minOrderQuantity),facets,breadcrumbs,pagination(DEFAULT),sorts(DEFAULT),freeTextSearch,currentQuery',
        productSuggestions: 'knbr/customers/${customerId}/products/suggestions',
      },
    },
  },
};

export const knBrProductViewConfig: ViewConfig = {
  view: {
    infiniteScroll: {
      active: true,
      productLimit: 1,
      showMoreButton: true,
    },
  },
};
